import * as React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

interface IProps {
    header: string,
    reload: () => void,
    children: any
}

export class TablePageHeader extends React.Component<IProps, any> {
    public render() {
        return <div style={{ margin: "15px 0" }}>
            <table style={{ width: "100%" }}>
                <tbody>
                    <tr>
                        <td style={{ paddingRight: "10px", width: "1%", whiteSpace: "nowrap" }}>
                            <span style={{ fontSize: "1.25rem", fontWeight: 500 }}>
                                {this.props.header}
                            </span>
                            <span style={{ paddingLeft: "10px", cursor: "pointer" }} onClick={this.props.reload}>
                                <FontAwesomeIcon icon="sync-alt" />
                            </span>
                        </td>
                        <td>
                            {this.props.children}
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>
    }
}
